<template>
  <div class="total-list">
    <div class="head">
      <div class="market">数据</div>
      <div class="sh">沪市</div>
      <div class="sz">深市</div>
      <div class="total">合计</div>
    </div>
    <div class="total-tr">
      <div class="market">融资余额</div>
      <div class="sh">{{ formatUnit(total.sh.FinanceValue) }}</div>
      <div class="sz">{{ formatUnit(total.sz.FinanceValue) }}</div>
      <div class="total">{{formatUnit(total.sh.FinanceValue + total.sz.FinanceValue)}}</div>
    </div>
    <div class="total-tr">
      <div class="market">融资较上日比</div>
      <div class="sh" :class="{'red': total.sh.FinanceValueDiff > 0, 'green': total.sh.FinanceValueDiff < 0}">{{ formatUnit(total.sh.FinanceValueDiff) }}</div>
      <div class="sz" :class="{'red': total.sz.FinanceValueDiff > 0, 'green': total.sz.FinanceValueDiff < 0}">{{ formatUnit(total.sz.FinanceValueDiff) }}</div>
      <div class="total" :class="{'red': total.sh.FinanceValueDiff + total.sz.FinanceValueDiff > 0, 'green': total.sh.FinanceValueDiff + total.sz.FinanceValueDiff < 0}">{{ formatUnit(total.sh.FinanceValueDiff + total.sz.FinanceValueDiff) }}</div>
    </div>
    <div class="total-tr">
      <div class="market">融券余额</div>
      <div class="sh">{{ formatUnit(total.sh.SecurityValue) }}</div>
      <div class="sz">{{ formatUnit(total.sz.SecurityValue) }}</div>
      <div class="total">{{ formatUnit(total.sh.SecurityValue + total.sz.SecurityValue) }}</div>
    </div>
    <div class="total-tr">
      <div class="market">融券较上日比</div>
      <div class="sh" :class="{'red': total.sh.SecurityValueDiff > 0, 'green': total.sh.SecurityValueDiff < 0}">{{ formatUnit(total.sh.SecurityValueDiff) }}</div>
      <div class="sz" :class="{'red': total.sz.SecurityValueDiff > 0, 'green': total.sz.SecurityValueDiff < 0}">{{ formatUnit(total.sz.SecurityValueDiff) }}</div>
      <div class="total" :class="{'red': total.sh.SecurityValueDiff + total.sz.SecurityValueDiff > 0, 'green': total.sh.SecurityValueDiff + total.sz.SecurityValueDiff < 0}">{{ formatUnit(total.sh.SecurityValueDiff + total.sz.SecurityValueDiff) }}</div>
    </div>
    <div class="total-tr">
      <div class="market">两融余额</div>
      <div class="sh">{{ formatUnit(total.sh.FiSecuValue) }}</div>
      <div class="sz">{{ formatUnit(total.sz.FiSecuValue) }}</div>
      <div class="total">{{ formatUnit(total.sh.FiSecuValue + total.sz.FiSecuValue) }}</div>
    </div>
    <div class="total-tr">
      <div class="market">融资余额占流通市值比</div>
      <div class="sh">{{ total.sh.FinaInTVRatio ? (total.sh.FinaInTVRatio * 100).toFixed(2) + '%' : '--' }}</div>
      <div class="sz">{{ total.sz.FinaInTVRatio ? (total.sz.FinaInTVRatio * 100).toFixed(2) + '%' : '--' }}</div>
      <div class="total">{{ (total.sz.FinaInTVRatio && total.sh.FinaInTVRatio) ? ((total.sh.FinaInTVRatio + total.sz.FinaInTVRatio) * 100).toFixed(2) + '%' : '--' }}</div>
    </div>
  </div>
</template>
<script>
import rzrq from '@/api/rzrq'
import {request} from '@/api/request'
import Utils from '@/utils/formatUnit'

export default {
  props: {
    tab: {
      type: String,
      required: true
    },
    date: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      total: {
        sz: {},
        sh: {}
      }
    }
  },
  watch: {
    date() {
      this.getRzrqTotal()
    }
  },
  async created() {
    await this.getRzrqTotal()
  },
  methods: {
    formatUnit(val) {
      if(!val) return '--'
      return Utils.formatUnit(val)
    },
    async getRzrqTotal() {
      if (!this.date) return
      for (const key in this.total) {
        const res = await request.get({
          url: rzrq.query2FinaSecuTable,
          params: {market: key, date: this.date}
        })
        if(res){
          this.total[key] = res
        }
      }
    }
  },
  computed: {
    
  },
}
</script>
<style lang="stylus" scoped>
.total-list
  padding .08rem .12rem
.head
  display flex
  color #999999
  font-size .13rem
  margin-bottom .04rem
.market
    width .98rem
    text-align left
.sh
    width .81rem
    text-align right
.sz,.total
    width .86rem  
    text-align right
.total-tr
  display flex
  line-height .2rem
  &:not(:last-child)
    margin-bottom .06rem
  .market
    font-size .14rem
    color #333333
    font-family PingFangSC-Regular,PingFang SC
  .sh,.sz,.total
    font-weight 500
    font-family PingFangSC-Medium,PingFang SC
    color #333333
  .red
    color #F43737
  .green
    color #1BAA3C
</style>